"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchContractInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const mui_inputs_entity_1 = require("@dzambalaorg/mui-inputs-entity");
const types_collection_1 = require("@dzambalaorg/types-collection");
const types_1 = require("@framework/types");
const types_2 = require("../../types");
const SearchContractInput = (props) => {
    const { prefix, service } = props;
    const form = (0, react_hook_form_1.useFormContext)();
    const tokenType = (0, react_hook_form_1.useWatch)({ name: `${prefix}.tokenType` });
    const emptyReward = (0, react_hook_form_1.useWatch)({ name: "emptyReward" });
    const merchantId = (0, react_hook_form_1.useWatch)({ name: "merchantId" });
    const disabled = service === types_2.ServiceType.ADMIN && prefix === "reward" && emptyReward;
    const fetchData = (0, react_1.useMemo)(() => {
        const baseFetchData = {
            contractType: [tokenType],
            contractStatus: [types_1.ContractStatus.ACTIVE, types_1.ContractStatus.NEW],
            contractModule: [types_1.ModuleType.HIERARCHY],
        };
        const fetchDataByServiceType = {
            [types_2.ServiceType.ADMIN]: baseFetchData,
            [types_2.ServiceType.OFFICE]: { ...baseFetchData, merchantId },
        };
        return fetchDataByServiceType[service];
    }, [service, tokenType, merchantId]);
    (0, react_1.useEffect)(() => {
        form.setValue(`${prefix}.contractId`, types_collection_1.InputType.awaited);
    }, [tokenType, merchantId]);
    return ((0, jsx_runtime_1.jsx)(mui_inputs_entity_1.EntityInput, { name: `${prefix}.contractId`, controller: "contracts", disabled: disabled, fetchData: fetchData, autoSelect: true, disableClear: true }));
};
exports.SearchContractInput = SearchContractInput;
//# sourceMappingURL=index.js.map